import React, { useState, useEffect, useRef } from 'react';
import { FundRequestStatus } from '~/enums/fundRequest';

interface StatusUpdateModalProps {
    onStatusChange: (status: FundRequestStatus) => void;
    statuses: { label: string; value: FundRequestStatus }[];
    currentStatus?: string;
}

const StatusUpdateModal: React.FC<StatusUpdateModalProps> = ({
    onStatusChange,
    statuses,
    currentStatus,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleStatusChange = (status: {
        label: string;
        value: FundRequestStatus;
    }) => {
        onStatusChange(status.value);
        setIsOpen(false);
    };

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div className='relative' ref={dropdownRef}>
            <button
                className='rounded-full border-[2px] border-transparent px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-200 hover:border-[#e6f7f8] hover:bg-[#e6f7f8]'
                onClick={() => setIsOpen(!isOpen)}
            >
                Update Status
            </button>
            {isOpen && (
                <div className='absolute right-0 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5'>
                    <div
                        className='py-1'
                        role='menu'
                        aria-orientation='vertical'
                        aria-labelledby='options-menu'
                    >
                        {statuses.map((status) => (
                            <button
                                key={status.value}
                                onClick={() => handleStatusChange(status)}
                                className={`block w-full px-4 py-1 text-left text-sm font-medium ${currentStatus === status.value
                                        ? 'bg-gray-100 text-gray-900'
                                        : 'text-gray-700'
                                    } hover:bg-gray-100 hover:text-gray-900`}
                                role='menuitem'
                            >
                                {status.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default StatusUpdateModal;
